// extracted by mini-css-extract-plugin
export default {"container":"styles_container__mZGtH","content":"styles_content__Op0AZ"};